<template>
  <div v-if="items.length">
    <EsiaMenu />
    <div class="container">
      <div class="grid-row">
        <div
          class="col-3 col-md-6 push-lg-3 col-lg-6 mb-16 roles-list -ms-start-lg-1"
        >
          <EsiaOrgList
            :items="items"
            item-key-id="esiaId"
            item-key-name="fullName"
            @item-click="onEsiaOrgListItemClick"
          />
        </div>
      </div>
    </div>
  </div>
  <div v-else class="esia-auth-picker__failure">
    <p>Нет доступных организаций для выбора.</p>
    <p>Пожалуйста, повторите вход, используя другую учетную запись.</p>
    <button class="esia-auth-picker__failure-button" @click="onLogoutClick">
      Выход
    </button>
  </div>
</template>

<script lang="ts" setup>
/*  eslint-disable @typescript-eslint/no-explicit-any */
import { IItem } from '../../types';
import tokenApplyOrg from '../../utils/tokenApplyOrg';
import EsiaMenu from '../EsiaMenu';
import EsiaOrgList from '../EsiaOrgList';

export interface IProps {
  baseGet?: () => string;
  items: IItem[];
  keycloak: any;
  notifyError?: (msg: string, cfg?: any) => void;
}

const props = defineProps<IProps>();
const emit = defineEmits(['pick']);

/* Methods */
const itemPick = async (item: IItem) => {
  await tokenApplyOrg({
    adapterCfg: { keycloak: props.keycloak },
    base: props.baseGet?.(),
    item,
    notifyError: props.notifyError,
  });
  emit('pick', item);
};

/* Handlers */
const onEsiaOrgListItemClick = (item: IItem) => {
  itemPick(item);
};

const onLogoutClick = () => {
  props.keycloak.logout();
};
</script>

<style lang="scss" scoped>
@import '../../assets/styles/sass/container.scss';
@import '../../assets/styles/sass/grid.scss';
@import './style.scss';
</style>
